import ResolverError from "./ResolverError.mjs";
/**
 * @public
 */
class UnmatchedResolverError extends ResolverError {}
export default UnmatchedResolverError;